exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#divResult {\n  overflow-y: scroll;\n  overflow-x: hidden;\n  min-height: 200px;\n  width: 100%;\n  left: 1px;\n  position: relative;\n  background-color: white;\n}\n#divResult .table tr td,\n  #divResult .table tr th {\n    border: 1px inset;\n    text-align: center;\n}\n", ""]);

